import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { HiddenCost } from './components/HiddenCost';
import { PainSection } from './components/PainSection';
import { Solution } from './components/Solution';
import { TomosGrid } from './components/TomosGrid';
import { TomoIncludes } from './components/TomoIncludes';
import { BonusSection } from './components/BonusSection';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
const META_PIXEL_ID = '1289554852658050';
export function App() {
  useEffect(() => {
    const w = window as any;
    // If already initialized, just fire a PageView and exit
    if (w.fbq) {
      w.fbq('track', 'PageView');
      return;
    }
    // Initialize fbq stub (mirrors Meta's official base snippet)
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    w.fbq = n;
    if (!w._fbq) w._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    // Inject the Facebook events script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // Track first page view
    w.fbq('init', META_PIXEL_ID);
    w.fbq('track', 'PageView');
    // Noscript fallback pixel
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  return <div className="min-h-screen bg-[#FAF8F5] text-ink-800 font-sans selection:bg-brand-500 selection:text-white" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <HiddenCost data-id="element-3" />
        <PainSection data-id="element-4" />
        <Solution data-id="element-5" />
        <TomosGrid data-id="element-6" />
        <TomoIncludes data-id="element-7" />
        <BonusSection data-id="element-8" />
        <Pricing data-id="element-9" />
        <Testimonials data-id="element-10" />
        <Guarantee data-id="element-11" />
        <FAQ data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}